module.exports = __webpack_public_path__ + "static/media/banner-photo768@3x.f19a6ae3.webp";